<template>
	<div>
		<div v-if="this.mc">
			<div style="background:var(--grey-4);padding:5px;margin-bottom:5px;border-radius: 5px;" :title="this.title"
				class="flexcenter link" @click.stop="this.$emit('searchMcSelected', this.mc)">


				<div>
					<b>{{ this.mc.modelName }}</b><br />
					<span style="color:grey;margin-left:0px;font-size:85%;">{{ this.mc.brandName }}</span>
				</div>


				<b style="flex-grow:1;">&nbsp;</b>
				<div style="background:var(--grey-5);padding:3px;border-radius: 5px;">{{ this.mc?.productListAll?.length }}</div>
				<Icon v-if="!this.isOnProductListPage()" fileName="w3_chevron_right_dark" style="height:15px;width:10px;margin-left:5px;" />
			</div>
		</div>
		<div v-if="!this.mc">Ingen mc {{ this.mcId }} - {{ this.brandId }}</div>
	</div>
</template>
<script>
import { STORE_GETTER } from '@/store/store';
import { routerMixin } from "@/mixins/routerMixin.js";

//import SelectManufactor from '@/components/product/search/SelectManufactor.vue';
//import { STORE_GETTER } from '@/store/store';

export default {
	name: "SearchMcRow",
	components: {},
	mixins: [routerMixin],
	props:{
		brandId: Number,
		mcId: Number
	},
	data() {
		return {

		};
	},
	computed: {

	

		mc() {

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL];
			
			if (baseModel && baseModel.mcTree) {

				const brand = baseModel.mcTree.find(brand => brand.id == this.brandId);

				if (brand){
					const mc = brand.modelList.find(mc => mc.mcId == this.mcId)
					return mc;
				}
				
				
			}

			return null;

		},



		title() {
			if (this.isOnProductListPage()) {
				return "MC-Modeller MC"
			} else {
				return "Visa alla produkter som passar till " + this.mc?.brandName + " " + this.mc?.modelName
			}
		}



	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);

		// this.$store.dispatch({ type: PRODUCT_STORE_ACTION.TEST_GET_PRODUCT_LIST, data: {} });


	},
	created() {

	}
};
</script>

<style scoped></style>